import { Avatar, ButtonBase, ButtonBaseProps } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export default function MenuButton(props: ButtonBaseProps) {
  return (
    <ButtonBase {...props}>
      <Avatar
        variant="rounded"
        sx={{
          height: 30,
          width: 30,
          bgcolor: (theme) => theme.palette.primary.light,
          alignContents: "center",
          ml: 1,
        }}
      >
        <MenuIcon
          fontSize="small"
          sx={{
            color: (theme) => theme.palette.primary.contrastText,
          }}
        />
      </Avatar>
    </ButtonBase>
  );
}
